import { render, staticRenderFns } from "./bookingspace.vue?vue&type=template&id=f6a9db16"
import script from "./bookingspace.vue?vue&type=script&lang=js"
export * from "./bookingspace.vue?vue&type=script&lang=js"
import style0 from "./bookingspace.vue?vue&type=style&index=0&id=f6a9db16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports